
import { Component, Input, OnInit, Inject, EventEmitter, Output } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable, } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import { Queue } from '../../../shared/dataModels/Queue';
import { IErrorHandler } from '../../../shared/dataModels/contracts/IErrorHandler';
import { Configuration } from '../../../shared/configurations/shared.config';
import { FileUploader } from '../../../shared/components/fileUpload/classes/file-uploader.class';
import { LocalizePipe } from '../../../shared/pipes/Localize.pipe';
import { FileSelectDirective } from '../../../shared/components/fileUpload/directives/file-select.directive';

@Component({
    moduleId: module.id,
    selector: 'file-attachment',
    templateUrl: 'file-attachment.component.html',
    styleUrls: ['file-attachment.component.scss'],
    providers: [FileSelectDirective]
})
export class FileAttachment implements OnInit {

    @Input() type: string;
    @Input() allowedTypes: string;
    @Input() maxFileSize: number;
    @Input() maxFileNameLength: number = 250;
    @Input() url: string = Configuration.urls.webApiEndpoint + Configuration.urls.attachmentUrl;

    @Output() onFileUploaded: EventEmitter<number> = new EventEmitter<number>();

    @Input() viewMode: boolean = false;


    messagesQueue: string[] = [];
    queuInterval: any;
    previewFiles: any[] = [];
    deletedFiles: any[] = [];
    isSuccess = false;
    fileName: string;
    failedToUpload: boolean = false;

    messagesSubject: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

    private _errorHandler: IErrorHandler;
    public uploader: FileUploader;

    constructor(private _http: Http, @Inject("IErrorHandler") handler: IErrorHandler, private _localizer: LocalizePipe) {

        this._errorHandler = handler;
    }

    ngOnInit() {

        this.uploader = new FileUploader(
            {
                url: this.url,
                headers: [{ name: 'attach-type', value: this.type }],
                allowedFileType: this.allowedTypes,
                maxFileSize: this.maxFileSize,
                maxFileNameLength: this.maxFileNameLength
            });

        //File Upload Completed
        this.uploader.fileUploadCompleted.subscribe(metadata => {

            if (metadata && metadata.response) {

                var response = JSON.parse(metadata.response);

                var index = this.uploader.queue.findIndex(x => x == metadata.item);

                if (index >= 0) {

                    this.uploader.queue[index].isSuccess = !response.IsErrorState;
                    this.uploader.queue[index].isError = response.IsErrorState;

                    if (!response.IsErrorState) {
                        this.uploader.queue[index].attachmentId = response.Value.Id;
                        this.uploader.queue[index].url = response.Value.Url;
                        this.uploader.queue[index].metadata = response;
                        this.onFileUploaded.emit(this.uploader.queue[index].attachmentId);
                    }
                }
            }

            this.failedToUpload = false;
            this.messagesQueue = [];
        });

        this.uploader.fileAdded.subscribe(file => {
            this.failedToUpload = false;
            this.messagesQueue = [];
        });

        //Filed Failed To Upload
        this.uploader.fileFailedToUpload.subscribe(metadata => {

            if (metadata) {

                if (metadata.filter.name == "fileType") {

                    this.messagesQueue.push(metadata.item.name + this._localizer.transform("FileAttachment_FileTypesErrorMessage") + this.allowedTypes.replace(/,/g, ", "));

                }
                else if (metadata.filter.name == "fileSize") {

                    if (this.maxFileSize / 1024 / 1024 < 1) {

                        this.messagesQueue.push(metadata.item.name + this._localizer.transform("FileAttachment_MaxFileSizeErrorMessage") + this.maxFileSize / 1024 + this._localizer.transform("FileAttachment_MB"));
                    }
                    else {
                        this.messagesQueue.push(metadata.item.name + this._localizer.transform("FileAttachment_MaxFileSizeErrorMessage") + this.maxFileSize / 1024 / 1024 + this._localizer.transform("FileAttachment_MB"));
                    }
                }
                else if (metadata.filter.name == "fileName") {
                    this.messagesQueue.push(metadata.item.name + this._localizer.transform("FileAttachment_MaxFileErrorMessage") + this.maxFileNameLength + this._localizer.transform("FileAttachment_Characters"));

                }
                else if (metadata.filter.name == "fileDuplicate") {
                    this.messagesQueue.push(metadata.item.name + this._localizer.transform("FileAttachment_FileExistErrorMessage"));

                }

                this.showMessageQueue();
            }
        })
    }

    validate(): boolean {

        if (this.uploader.queue.length == 0) {
            return true;
        }

        for (var item of this.uploader.queue) {

            if (!item.isSuccess) {

                //Error Message
                var msg: string = this._localizer.transform("FileAttachment_UploadMessage");

                //if it displayed before
                var index = this.messagesQueue.findIndex(x => x == msg);

                //if not exist, push to queue
                if (index < 0) {
                    this.messagesQueue.push(msg);
                    this.showMessageQueue();
                }

                return false;
            }
        }

        return true;
    }

    getAllAttachment(): any[] {

        var objects: any[] = [];
        var uploadedFiles: any[] = this.uploader.queue.filter((file) => file.isSuccess);

        if (uploadedFiles && uploadedFiles.length > 0) {

            uploadedFiles.forEach(attach => {

                objects.push(attach.metadata.Value);
            });
        }

        if (this.previewFiles && this.previewFiles.length > 0) {

            this.previewFiles.forEach(file => {

                objects.push(file);
            });
        }

        if (this.deletedFiles && this.deletedFiles.length > 0) {

            this.deletedFiles.forEach(file => {

                objects.push(file);
            });
        }

        return objects;
    }

    remove(item): void {

        if (item) {

            if (item.isUploaded && item.attachmentId && item.EntityId) {

                var deletedItem = item;
                deletedItem.IsDeleted = true;
                this.deletedFiles.push(deletedItem);
            }

            item.remove();
        }
    }

    removeAll(): void {

        if (this.uploader.queue) {

            for (var item of this.uploader.queue) {
                this.remove(item);
            }

            this.uploader.clearQueue();
        }

        if (this.previewFiles) {

            for (var item of this.previewFiles) {
                this.removePreview(item, false);
            }

            this.previewFiles = [];
        }

    }

    removePreview(item, removeFromList = true) {

        if (item && this.previewFiles && this.previewFiles.length > 0) {

            var index = this.previewFiles.findIndex(file => file.Id == item.Id);

            if (index >= 0) {

                item.IsDeleted = true;
                this.deletedFiles.push(item);

                if (removeFromList) {
                    this.previewFiles.splice(index, 1);
                }
            }
        }
    }

    clearQueue() {
        //Clear Files Queue
        this.uploader.clearQueue();
        this.previewFiles = [];
        this.deletedFiles = [];
        //Clear Message Queue
        this.messagesQueue = [];
        this.failedToUpload = false;
    }

    addFiles(files: any[]) {

        if (files) {

            this.previewFiles = files;
        }
    }

    showMessageQueue() {

        this.failedToUpload = true;
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/fileAttachment/file-attachment.component.ts